import { render } from "./MenuPanel.vue?vue&type=template&id=2a060565&ts=true"
import script from "./MenuPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuPanel.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/MenuPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a060565"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a060565', __exports__)) {
    api.reload('2a060565', __exports__)
  }
  
  module.hot.accept("./MenuPanel.vue?vue&type=template&id=2a060565&ts=true", () => {
    api.rerender('2a060565', render)
  })

}


export default __exports__